import { Rodada } from 'src/app/domain/primecap/model/rodada';
import { CapTable } from '../cap-table';
import { DescricaoRodada } from '../descricao-rodada';
import { Documento } from '../documento';
import { StatusRodadaEnum } from '../enum/status-rodada.enum';
import { Faturamento } from '../faturamento';
import { Socio } from '../socio';

export class CadastroRodada {
  uuid: string;
  tipoRodada: string;
  protocoloRodadaCvm: string;
  valor: number;
  valorCota: number;
  dataInicio: Date;
  dataTermino: Date;
  feeNegociado: number;
  banner: string;
  logo: string;
  linkVideo: string;
  modeloContratoUuid: string;
  textoCard: string;
  status: StatusRodadaEnum;
  empresaUuid: string;
  empresaNome: string;
  empresaSetor: string;
  empresaSetorCorTag: string;
  empresaFacebook: string;
  empresaInstagram: string;
  empresaSite: string;
  empresaLogo: string;
  empresaLinkedin: string;
  listaDescricaoRodada: DescricaoRodada[];
  listaDocumento: Documento[];
  equityOferecido: number; // rodada equity
  rentabilidadeOferecida: number; // rodada divida
  vencimentoTitulo: Date; // rodada divida;
  quantidadeInvestidores: number;
  valorCaptado: number;
  valorMinimoSucesso: number;
  listaSocio: Socio[];
  listaFaturamento: Faturamento[];
  listaCapTable: CapTable[];
  emissao: number; // rodada divida com nota comercial
  serie: string; // rodada divida com nota comercial
  quantidadeCotas: number; // rodada divida com nota comercial

  constructor(rodada: Rodada) {
    this.uuid = rodada.uuid;
    this.tipoRodada = rodada.tipoRodada;
    this.protocoloRodadaCvm = rodada.protocoloRodadaCvm;
    this.valor = rodada.valor;
    this.valorCota = rodada.valorCota;
    this.dataInicio = rodada.dataInicio;
    this.dataTermino = rodada.dataTermino;
    this.feeNegociado = rodada.feeNegociado;
    this.banner = rodada.banner;
    this.logo = rodada.logo;
    this.linkVideo = rodada.linkVideo;
    this.modeloContratoUuid = rodada.modeloContratoUuid;
    this.textoCard = rodada.textoCard;
    this.status = rodada.status;
    this.empresaUuid = rodada.empresaUuid;
    this.empresaNome = rodada.empresaNome;
    this.empresaSetor = rodada.empresaSetor;
    this.empresaSetorCorTag = rodada.empresaSetorCorTag;
    this.empresaFacebook = rodada.empresaFacebook;
    this.empresaInstagram = rodada.empresaInstagram;
    this.empresaSite = rodada.empresaSite;
    this.empresaLogo = rodada.empresaLogo;
    this.empresaLinkedin = rodada.empresaLinkedin;
    this.listaDescricaoRodada = rodada.listaDescricaoRodada;
    this.listaDocumento = rodada.listaDocumento;
    this.equityOferecido = rodada.equityOferecido;
    this.rentabilidadeOferecida = rodada.rentabilidadeOferecida;
    this.vencimentoTitulo = rodada.vencimentoTitulo;
    this.quantidadeInvestidores = rodada.quantidadeInvestidores;
    this.valorCaptado = rodada.valorCaptado;
    this.valorMinimoSucesso = rodada.valorMinimoSucesso;
    this.listaSocio = rodada.listaSocio;
    this.listaFaturamento = rodada.listaFaturamento;
    this.listaCapTable = rodada.listaCapTable;
    this.emissao = rodada.emissao;
    this.serie = rodada.serie;
    this.quantidadeCotas = rodada.quantidadeCotas;
  }
}
